const iconPackMapper = {
  arrowLeft: "ri:arrow-left-line",
  arrowRight: "ri:arrow-right-line",
  cart: "ri:shopping-cart-line",
  check: "ri:check-line",
  chevronDown: "ri:arrow-down-s-line",
  chevronLeft: "ri:arrow-left-s-line",
  chevronRight: "ri:arrow-right-s-line",
  chevronUp: "ri:arrow-up-s-line",
  circleCheck: "ri:checkbox-circle-fill",
  circleCloseFill: "ri:close-circle-fill",
  circleCloseOutlined: "ri:close-circle-line",
  circleInfo: "ri:information-fill",
  circleInfoOutlined: "ri:information-line",
  circleWarningOutlined: "ri:error-warning-line",
  clock: "ri:time-line",
  close: "ri:close-line",
  menu: "ri:menu-line",
  pen: "ri:pencil-line",
  play: "ri:play-fill",
  plus: "ri:add-line",
  minus: "ri:subtract-line",
  search: "ri:search-line",
  settings: "ri:equalizer-3-fill",
  spinner: "ri:loader-2-line",
  trash: "ri:delete-bin-fill",
  truck: "ri:truck-fill",
  user: "ri:user-line",
  email: "ri:mail-line",
  externalLink: "ri:external-link-line",
  volumeOn: "ri:volume-up-line",
  volumeOff: "ri:volume-mute-line",
  pause: "ri:pause-fill",
  cogs: "ri:settings-4-line",
  heart: "ri:heart-line",
  filledHeart: "ri:heart-fill",
  filledHeartAdd: "ri:heart-add-fill",
  appleAppStore: "ri:apple-fill",
  googlePlayStore: "ri:google-play-fill",
  facebook: "ri:facebook-fill",
  twitter: "ri:twitter-x-fill",
  instagram: "ri:instagram-fill",
  youtube: "ri:youtube-fill",
  weibo: "ri:weibo-fill",
  wechat: "ri:wechat-fill",
  charity: "ri:hand-heart-fill",
  partner: "ri:shake-hands-fill",
  checkboxBlank: "ri:checkbox-blank-circle-line",
  checkboxChecked: "ri:checkbox-circle-fill",
  mobile: "ri:smartphone-line",
  house: "ri:home-2-line",
  card: "ri:bank-card-2-fill",
  locationPin: "ri:map-pin-2-fill",
  cactus: "ri:cactus-fill",
  bidding: "ri:auction-fill",
  football: "ri:football-fill",
  automatic: "ri:input-method-line",
  bell: "ri:notification-3-line",
  filledBell: "ri:notification-2-fill",
  checkDouble: "ri:check-double-line",
  sortDesc: "ri:sort-desc",
  sortAsc: "ri:sort-asc",
  zoomIn: "ri:zoom-in-line",
  zoomOut: "ri:zoom-out-line",
  rotate: "ri:refresh-line",
  globe: "ri:earth-line",
  category: "ri:function-line",
} as const;

export default iconPackMapper;
